export default __webpack_public_path__ + "static/media/boulevard.f5e910ae.png";